
import Hourglass from '../../../assets/svg/Hourglass';
import useTranslation from '../../../hooks/useTranslation';
import StatusPage from '../StatusPage';

const StatusWaitingPage = () => {
    const translate = useTranslation();

    return (
        <StatusPage
            icon={<Hourglass />}
            title={translate(`page.status-waiting.title`)}
            body={translate(`page.status-waiting.description`)}
            alertTitle={translate(`page.status-waiting.alert.title`)}
            alertSubtitle={translate(`page.status-waiting.alert.subtitle`)}
            alertSeverity="info"
        />
    );
};

export default StatusWaitingPage;
